import React from 'react';
import PropTypes from 'prop-types';

import { Heading } from 'Components/molecules/Heading';
import { HtmlSafe } from 'polaris-coreweb/exports';
import { withPolaris } from 'Components/protons/Polaris';

import './_style.scss';

/**
 * NumberedListBlock component
 *
 * This component renders a block with a numbered list.
 *
 * @param {Object} context - Context object containing additional information
 * @param {string} cssPrefix - CSS prefix for class names
 * @param {string} title - Title of the numbered list block
 * @param {Array} data - Array of data objects for the list items
 * @param {string} data[].title - Title of the list item
 * @param {string} data[].content - Content of the list item (optional)
 */
export const NumberedListBlock = ({
  context: {
    cssPrefix,
  },
  title,
  data,
}) => (
  <div className={`${cssPrefix}__numbered-list-block`}>
    <Heading
      size={2}
      extraClassNames={{
        [`${cssPrefix}__numbered-list-block--title`]: true,
      }}
    >
      <span>{title}</span>
    </Heading>
    <div className={`${cssPrefix}__numbered-list-block--list`}>
      {data && Array.isArray(data) && data.map((item, index) => (
        <div className={`${cssPrefix}__numbered-list-block--list-item`} key={index}>
          <div className={`${cssPrefix}__numbered-list-block--list-item--number`}>{index + 1}</div>
          <div className={`${cssPrefix}__numbered-list-block--list-item--block`}>
            <div className={`${cssPrefix}__numbered-list-block--list-item--title`}><p>{item.title}</p></div>
            {item.content && (
            <div className={`${cssPrefix}__numbered-list-block--list-item--content`}>
              <HtmlSafe html={item.content} />
            </div>
            )}
          </div>
        </div>
      ))}
    </div>
  </div>
);

NumberedListBlock.propTypes = {
  context: PropTypes.shape({
    cssPrefix: PropTypes.string,
  }),
  title: PropTypes.string,
  data: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string,
      content: PropTypes.string,
    }),
  ),
};

NumberedListBlock.defaultProps = {
  context: {
    cssPrefix: 'polaris',
  },
  title: '',
  data: [],
};

export default withPolaris(NumberedListBlock);
